import(/* webpackMode: "eager", webpackExports: ["Skeleton"] */ "__barrel_optimize__?names=Skeleton!=!/app/node_modules/antd/es/index.js");
